import { Component } from '@angular/core';
import { CorePageBaseComponent } from './core-page-base.component';

@Component({ template: '' })
/** Base Component Class for page elements */
export class CoreReviewPageRendererBaseComponent extends CorePageBaseComponent {}
